<template>
    <div class="d-flex justify-center pa-md-5 mx-lg-auto">
        <v-card class="d-flex justify-center mb-6" v-if="personal" style="max-width: 600px" elevation="2">
            <v-form class="pa-md-4 mx-lg-auto" ref="form" style="min-width: 350px" v-model="valid" lazy-validation>
                <v-autocomplete v-model="form.vendedora" :rules="vendedoraRules" :items="personal"
                    label="Vendedor"></v-autocomplete>
                <v-autocomplete v-model="form.personalCargo" :rules="personalCargoRules" :items="personal"
                    label="Personal a Cargo"></v-autocomplete>

                <!-- Producto principal — solo si NO viene idVenta por query -->
                <v-autocomplete
                    v-if="!$route.query.idVenta"
                    v-model="form.mainProduct"
                    :rules="mainProductRules"
                    :items="mainSearchResults"
                    :loading="isMainSearching"
                    :search-input.sync="mainProductSearch"
                    item-text="rename"
                    item-value="id"
                    label="Producto a Equipar"
                    placeholder="Buscar producto (mín. 4 caracteres)"
                    return-object
                    no-filter
                    hide-no-data
                    @change="onMainProductSelected"
                >
                    <template v-slot:item="{ item }">
                        <v-chip small color="secondaryTheme" class="caption px-2" dark>{{ item.internal_id }}</v-chip>
                        <span class="caption ml-1">{{ item.rename }}</span>
                    </template>
                </v-autocomplete>

                <!-- Selector de Tipo de Equipamiento -->
                <v-row dense align="center">
                    <v-col cols="12" md="6">
                        <v-autocomplete
                            v-model="tipoEquipamientoSeleccionado"
                            :items="plantillasDisponibles"
                            item-text="tipo"
                            item-value="id"
                            label="Tipo de Equipamiento"
                            placeholder="Seleccionar tipo..."
                            clearable
                            outlined
                            dense
                            :disabled="loadingPlantilla"
                        />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-btn 
                            color="primary" 
                            @click="agregarKitPlantilla"
                            :loading="loadingPlantilla"
                            :disabled="!tipoEquipamientoSeleccionado || loadingPlantilla"
                            block
                        >
                            <v-icon left>mdi-playlist-plus</v-icon>
                            AGREGAR KIT
                        </v-btn>
                    </v-col>
                </v-row>

                <!-- Accesorios / sub-productos -->
                <form autocomplete="nope" @submit.prevent="postData">
                    <v-container grid-list-md fluid>
                        <v-row dense align="center">
                            <v-col cols="12" sm="12">
                                <v-autocomplete
                                    dense
                                    v-model="servicio"
                                    v-validate="'required'"
                                    label="Producto"
                                    :items="searchResults"
                                    :loading="isSearching"
                                    :search-input.sync="productSearch"
                                    placeholder="Buscar producto (mín. 4 caracteres)"
                                    data-vv-as="marca"
                                    :error-messages="errors.collect('servicio')"
                                    data-vv-name="servicio"
                                    required
                                    item-text="rename"
                                    item-value="id"
                                    return-object
                                    no-filter
                                    hide-no-data
                                    @change="onProductSelected"
                                >
                                    <template v-slot:item="{ item }">
                                        <v-chip small color="secondaryTheme" class="caption px-2" dark>{{ item.internal_id }}</v-chip>
                                        <span class="caption ml-1">{{ item.rename }}</span>
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field dense v-model="servicio.unidades" :rules="unidadesRules" label="Unidades"
                                    @keypress="isNumber" />
                            </v-col>
                            <v-col cols="12" sm="6" class="text-center">
                                <v-btn block color="secondaryTheme" dark type="submit">agregar</v-btn>
                            </v-col>
                            <v-spacer></v-spacer>
                        </v-row>
                    </v-container>
                </form>

                <v-col cols="12" class="grey lighten-5">
                    <v-data-table multi-sort :headers="headers" :items="_productos" class="elevation-1" :items-per-page="20"
                        item-key="timestamp">
                        <template v-slot:[`item.action`]="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" color="green"
                                        @click="upItem(item)">mdi-swap-vertical</v-icon>
                                </template>
                                <span>SUBIR</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="primary" v-bind="attrs" v-on="on" small
                                        @click="deleteItem(item)">mdi-delete</v-icon>
                                </template>
                                <span>ELIMINAR</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-col>

                <v-col cols="12" md="12">
                    <v-textarea v-model="form.observaciones" name="input-7-1" label="Observaciones" value=""></v-textarea>
                </v-col>
                <v-btn :disabled="!valid" :loading="loading" color="success" class="mr-4" @click="validate">
                    Generar
                </v-btn>
            </v-form>
        </v-card>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import { mixins } from '@/mixins/mixin.js'
import DefaultForm from '@/utils/defaultForm'
import { debounce } from 'lodash'
import request from '@/utils/request'

export default {
    filters: {},
    props: ['lista', 'service'],
    mixins: [mixins],
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            servicio: DefaultForm.formSelectServicio(),
            loading: false,
            valid: true,
            vendedoraRules: [(v) => !!v || 'Vendedora is required'],
            personalCargoRules: [(v) => !!v || 'personal is required'],
            mainProductRules: [(v) => !!v || 'Producto Principal is required'],
            unidadesRules: [(v) => !!v || 'unidad is required'],
            headers: [
                { text: 'Actions', value: 'action', sortable: false },
                { text: 'Descripción', value: 'description' },
                { text: 'Codigo', value: 'internal_id' },
                { text: 'Marca', value: 'model' },
                { text: 'Unidades', value: 'unidades' }
            ],
            // Búsqueda — accesorio (tabla de items)
            productSearch: '',
            searchResults: [],
            isSearching: false,
            // Búsqueda — producto principal
            mainProductSearch: '',
            mainSearchResults: [],
            isMainSearching: false,
            // Plantillas de equipamiento
            plantillasDisponibles: [],
            tipoEquipamientoSeleccionado: null,
            plantillaSeleccionada: null,
            loadingPlantilla: false,
            // Datos de la venta existente (cuando viene idVenta)
            dataVenta: null,
            dataProduct: null,
            form: {
                vendedora: '',
                observaciones: '',
                personalCargo: '',
                mainProduct: null
            }
        }
    },
    watch: {
        // Watcher para el select de accesorios
        productSearch: debounce(function(val) {
            if (this.servicio && this.servicio.id && this.servicio.rename === val) return
            if (this.servicio && this.servicio.id && this.servicio.rename !== val) {
                this.servicio = DefaultForm.formSelectServicio()
            }
            if (!val || val.trim().length < 4) {
                this.searchResults = []
                return
            }
            this.performSearch(val, 'accessory')
        }, 500),
        // Watcher para el select de producto principal
        mainProductSearch: debounce(function(val) {
            if (this.form.mainProduct && this.form.mainProduct.id && this.form.mainProduct.rename === val) return
            if (this.form.mainProduct && this.form.mainProduct.id && this.form.mainProduct.rename !== val) {
                this.form.mainProduct = null
            }
            if (!val || val.trim().length < 4) {
                this.mainSearchResults = []
                return
            }
            this.performSearch(val, 'main')
        }, 500)
    },
    computed: {
        ...mapState('users', ['personal', 'listaUser']),
        ...mapState('ventas', ['datos', 'productos']),
        ...mapState('usuarios', ['user']),
        _productos() {
            return this.productos
        }
    },
    async mounted() {
        await this.$store.dispatch('users/getPersonas')
        await this.cargarPlantillas()

        if (this.$route.query.idVenta) {
            this.form.vendedora = this.listaUser.find((x) => x.id == this.datos.idColaborador)?.nombres
            const obtenerVenta = await this.$store.dispatch('ventas/ventaProducto', {
                id: this.$route.query.idVenta
            })
            const productosVenta = typeof obtenerVenta.productos === 'string'
                ? JSON.parse(obtenerVenta.productos)
                : obtenerVenta.productos
            const obtenerProducto = productosVenta?.find(
                (x) => x.id === Number(this.$route.query.idProducto)
            ) || null
            this.dataVenta = obtenerVenta
            this.dataProduct = obtenerProducto
        }
    },
    methods: {
        async cargarPlantillas() {
            try {
                const { data } = await request({
                    url: '/ms/inventario/private/1.0/equipamiento/plantillas',
                    method: 'GET'
                })
                if (data.codigoRespuesta === '00') {
                    this.plantillasDisponibles = data.data.filter(p => p.activo)
                }
            } catch (error) {
                console.error('Error cargando plantillas:', error)
            }
        },

        async agregarKitPlantilla() {
            if (!this.tipoEquipamientoSeleccionado) return

            this.loadingPlantilla = true
            try {
                const { data } = await request({
                    url: `/ms/inventario/private/1.0/equipamiento/plantilla/${this.tipoEquipamientoSeleccionado}`,
                    method: 'GET'
                })

                if (data.codigoRespuesta === '00' && data.data) {
                    let items = data.data.items || []
                    // Manejar doble escape de JSON
                    if (typeof items === 'string') {
                        try {
                            let parsed = JSON.parse(items)
                            if (typeof parsed === 'string') parsed = JSON.parse(parsed)
                            items = Array.isArray(parsed) ? parsed : []
                        } catch (e) {
                            items = []
                        }
                    }
                    if (Array.isArray(items)) {
                    // Resolver id del producto desde internal_id
                    const idSede = this.$store.state.users.user.idSede
                    const resolvedItems = await Promise.all(
                        items.filter(item => item != null).map(async (item) => {
                            const internalId = item.internal_id || item.codigo || ''
                            let productId = item.id || null
                            if (!productId && internalId) {
                                try {
                                    const results = await this.$store.dispatch('productos/searchProductos', {
                                        text: internalId,
                                        idSede,
                                        showInternals: true
                                    })
                                    const match = results.find(p => p.internal_id === internalId)
                                    if (match) productId = match.id
                                } catch (e) { /* sin id, se queda null */ }
                            }
                            return { ...item, resolvedId: productId }
                        })
                    )

                    const itemsPlantilla = resolvedItems
                        .map(item => ({
                            id: item.resolvedId,
                            description: item.description || item.descripcion || '',
                            internal_id: item.internal_id || item.codigo || '',
                            model: item.model || item.marca || '',
                            unidades: item.unidades || 1,
                            price: item.price || item.precio || 0,
                            priceOrigen: item.priceOrigen || item.precio || 0,
                            subTotal: (item.price || item.precio || 0) * (item.unidades || 1),
                            idTipoMoneda: item.idTipoMoneda || 1,
                            comision: 0,
                            descuentos: 0,
                            timestamp: Date.now() + Math.random()
                        }))

                    const listaActual = [...this.productos]
                    const listaNueva = listaActual.concat(itemsPlantilla)
                    this.$store.commit('ventas/UPDATE_PRODUCTOS', listaNueva)

                    this.plantillaSeleccionada = data.data

                    this.$store.commit('mainUI/OPEN_BAR', {
                        state: true,
                        text: `Se agregaron ${itemsPlantilla.length} items del kit "${data.data.tipo}"`,
                        color: 'success',
                        timeout: 2000
                    })
                    }
                }
            } catch (error) {
                console.error('Error cargando plantilla:', error)
                this.$store.commit('mainUI/OPEN_BAR', {
                    state: true,
                    text: 'No se pudo cargar la plantilla de equipamiento',
                    color: 'error',
                    timeout: 3000
                })
            } finally {
                this.loadingPlantilla = false
            }
        },

        async performSearch(searchText, target) {
            if (target === 'main') this.isMainSearching = true
            else this.isSearching = true

            try {
                const results = await this.$store.dispatch('productos/searchProductos', {
                    text: searchText,
                    idSede: this.$store.state.users.user.idSede,
                    showInternals: true
                })
                const mapped = results.map((p) => ({
                    ...p,
                    rename: `${p.name || p.description} | ${p.internal_id}`,
                    price: p.sale_unit_price,
                    idTipoMoneda: p.currency_type_id === 'USD' ? 2 : 1,
                    marca: p.brandName || '',
                    medida: p.medida?.name || '',
                    color: p.color || '',
                    unidades: 1,
                    comision: 0,
                    descuentos: 0
                }))
                if (target === 'main') this.mainSearchResults = mapped
                else this.searchResults = mapped
            } catch (error) {
                console.error('Product search error:', error)
                if (target === 'main') this.mainSearchResults = []
                else this.searchResults = []
            } finally {
                if (target === 'main') this.isMainSearching = false
                else this.isSearching = false
            }
        },

        onMainProductSelected(product) {
            if (!product) {
                this.form.mainProduct = null
                return
            }
            this.form.mainProduct = {
                ...product,
                description: product.name || product.description
            }
        },

        onProductSelected(product) {
            if (!product) {
                this.servicio = DefaultForm.formSelectServicio()
                return
            }
            this.servicio = {
                ...product,
                description: product.name || product.description,
                price: product.sale_unit_price,
                unidades: 1,
                comision: 0,
                descuentos: 0,
                idTipoMoneda: product.idTipoMoneda || 1
            }
        },

        upItem(newItem) {
            const position = this.productos.findIndex((x) => x.timestamp == newItem.timestamp)
            const lista = Object.assign([], this.productos)
            if (position >= 1) {
                const oldItem = { ...lista[position - 1], timestamp: Date.now() }
                lista.splice(position, 1, oldItem)
                lista.splice(position - 1, 1, newItem)
                this.$store.commit('ventas/UPDATE_PRODUCTOS', lista)
            }
        },

        deleteItem(item) {
            const lista = this.productos.filter((v) => v.timestamp != item.timestamp)
            this.$store.commit('ventas/UPDATE_PRODUCTOS', lista)
        },

        _parseFloat(val) {
            return parseFloat(val) || 0
        },

        async validate() {
            const validacion = await this.$refs.form.validate()
            if (!validacion) return

            var today = new Date()
            var dd = String(today.getDate()).padStart(2, '0')
            var mm = String(today.getMonth() + 1).padStart(2, '0')
            var yyyy = today.getFullYear()
            today = `${yyyy}-${mm}-${dd}`

            const numeroPedido = Number(this.$route.query.idVenta)
            const { mainProduct } = this.form

            // Filtrar accesorios (excluir "Tina ")
            const found = this._productos.filter((el) => !el.description.includes('Tina '))

            this.loading = true
            const crearOrdenEquipamiento = await this.$store.dispatch('ventas/crearOrdenEquipamiento', {
                vendedor: this.form.vendedora,
                personalCargo: this.form.personalCargo,
                fechaEmision: today,
                ordenPedido: numeroPedido,
                producto: this.dataProduct?.description || mainProduct?.description || this._productos[0]?.description,
                model: this.dataProduct?.marca || mainProduct?.marca,
                medida: this.dataProduct?.medida || mainProduct?.medida,
                color: this.dataProduct?.color || mainProduct?.color,
                posicion: '-',
                observaciones: this.form.observaciones,
                items: found,
                tipoEquipamiento: this.tipoEquipamientoSeleccionado,
                plantillaId: this.plantillaSeleccionada?.id || null
            })

            await this.$store.dispatch('reporte/reporteOrdenEquipamiento', {
                orden: crearOrdenEquipamiento.data.id,
                vendedor: this.form.vendedora,
                fecha: today,
                ordenpedido: numeroPedido,
                personacargo: this.form.personalCargo,
                producto: this.dataProduct?.description || mainProduct?.description,
                model: this.dataProduct?.marca || mainProduct?.marca,
                medida: this.dataProduct?.medida || mainProduct?.medida,
                color: this.dataProduct?.color || mainProduct?.color,
                posicion: this.form.posicion,
                observacion: this.form.observaciones,
                items: found
            })
            // Auto-fill PROCESO INTERNO en la venta si los campos están vacíos
            // (Se ejecuta al cerrar la orden, no al crear)

            this.loading = false
            this.$router.push(`/logistica/orden-equipamiento/lista`)
        },

        postData() {
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    const servicio = {
                        ...this.servicio,
                        priceOrigen: this.servicio.sale_unit_price,
                        idTipoMoneda: this.servicio.idTipoMoneda || 1,
                        price: this._parseFloat(this.servicio.price),
                        subTotal: this._parseFloat(this.servicio.price) * this._parseFloat(this.servicio.unidades),
                        timestamp: Date.now()
                    }
                    const tipoCambio = servicio.idTipoMoneda === 1 ? 1 : null
                    this.$store.commit('ventas/UPDATE_DATOS', { idTipoMoneda: servicio.idTipoMoneda, tipoCambio })
                    const lista = this.productos.concat([servicio])
                    this.$store.commit('ventas/UPDATE_PRODUCTOS', lista)
                    this.servicio = DefaultForm.formSelectServicio()
                    this.searchResults = []
                    this.productSearch = ''
                }
            })
        }
    }
}
</script>
